import React, {useState, useEffect, useCallback, useRef, useContext} from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import {Grid, IconButton, Typography, TextField} from '@material-ui/core'
import './ReservationBookings.scss'
import SearchIcon from '@material-ui/icons/Search'
import useGetManagerApprovalGroupReducer from '../../state/reservation/get-approval-manager-group/reducer'
import {getApprovalManagerGroup} from '../../state/reservation/get-approval-manager-group/actions'
import _ from 'lodash'
import WalkingPanda from '../../common/LoadingIndicators/WalkingPanda'
import DateArea from './DateArea'
import InfoArea from './InfoArea'
import {ReservationCalendarMainContext} from './../../context/ReservationCalendarMain'
import {useMemo} from 'react'
import {SettingsContext} from '../../context/Settings/Settings'
import useCalendarViewContext from '../../context/CalendarView'
import CloseIcon from '@material-ui/icons/Close'
import InputAdornment from '@material-ui/core/InputAdornment'
const ReservationBookings = () => {
  const [value, setValue] = useState(0)
  const {groups} = useCalendarViewContext()
  const [groupIds, dispatch] = useGetManagerApprovalGroupReducer()
  const settings = useContext(SettingsContext)
  const [stillLoading, setStillLoading] = useState(true)
  const [itemSelected, setItemSelected] = useState({})
  const [status, setStatus] = useState('')
  const [state, setState] = useState('')
  const [tabActive, setTabActive] = useState('')
  const {configurationIds} = useContext(ReservationCalendarMainContext)
  const [itemUpdated, setItemUpdated] = useState({})
  const [filteredOptions, setFilteredOptions] = useState([])
  const [isSearching, setSearching] = useState(false)
  const [search, setSearch] = useState('')
  const [realSearch, setRealSearch] = useState('')

  const filteredGroupIds = useMemo(() => {
    const _resPermission = settings.data?.user_access_rules?.can_view?.reservations || []
    const _groups = groups.data.filter(f => (_resPermission || []).includes(f.key))

    const _groupIds = _.filter(groupIds?.data || [], f => !!_groups.find(ff => ff.id === f))
    const _configurationIds = _.filter(
      configurationIds || [],
      f => !!_groups.find(ff => ff.id === f)
    )
    return {
      approval: _groupIds,
      configuration: _configurationIds,
    }
  }, [groupIds, configurationIds, groups, settings])

  const tryCallApi = useCallback(() => {
    getApprovalManagerGroup(dispatch)
    setStillLoading(false)
    // eslint-disable-next-line
  }, [dispatch, realSearch])

  useEffect(() => {
    tryCallApi()
  }, [tryCallApi])

  let textInput = useRef()

  useEffect(() => {
    if (!search && !isSearching) {
      if (_.isEmpty(filteredGroupIds.approval) && _.isEmpty(tabActive)) {
        setTabActive('upcoming')
      } else if (_.isEmpty(tabActive)) {
        setTabActive('pending')
      }
    }
    if (isSearching && search === '') {
      textInput.current.focus()
    }
    // eslint-disable-next-line
  }, [filteredGroupIds, isSearching, search, textInput])

  function setItemData(item) {
    setItemSelected(item)
    setState(item.states)
    setStatus(item.status)
  }

  function areaTabSelect(key) {
    setTabActive(key)
    setItemSelected({})
  }

  const handleSearchText = e => {
    e.preventDefault()
    setSearch(e.target.value)
    if (e.target.value === '') {
      setRealSearch('')
    }
  }
  const handleSearch = e => {
    if ('Enter' === e.key) {
      if (isSearching === true) {
        if (search.startsWith('#')) {
          let newSearch = search.substring(1)
          setRealSearch(newSearch)
        } else {
          setRealSearch(search)
        }
      } else {
        setSearching(true)
      }
    }
  }
  return (
    <div className="ap-reservation-bookings">
      <Grid container item xs={12}>
        <Grid item xs={6} className="ap-reservation-bookings__reservation-container">
          <div className="ap-reservation-bookings__reservation-header">
            <div className="ap-reservation-bookings__reservation-title">Reservations</div>
            <div className="search-option-body-reservations">
              {!isSearching ? (
                <Typography className="ap-typography--sm"></Typography>
              ) : (
                <>
                  <TextField
                    ref={textInput}
                    onBlur={() => {
                      isSearching === true && search === ''
                        ? setSearching(false)
                        : setSearching(true)
                    }}
                    id="standard-basic"
                    type="text"
                    className="c-res-mod ap-list ap-scrollbar"
                    autoFocus
                    value={search}
                    onChange={handleSearchText}
                    onKeyDown={e => handleSearch(e)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{display: 'flex', alignItems: 'center', gap: 8}}
                        >
                          <CloseIcon
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                              setSearch('')
                              setRealSearch('')
                              setSearching(true)
                            }}
                          />
                          <div
                            style={{
                              height: 24,
                              width: 2,
                              backgroundColor: '#dcdcdc',
                            }}
                          />
                          <IconButton
                            type="submit"
                            className="ap-icon-button"
                            underline={false}
                            aria-label="search"
                            style={{padding: 0}}
                            onClick={() => {
                              if (isSearching === true && search.length !== 0) {
                                if (search.startsWith('#')) {
                                  let newSearch = search.substring(1)
                                  setRealSearch(newSearch)
                                } else {
                                  setRealSearch(search)
                                }
                              } else {
                                setSearching(true)
                              }
                            }}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </>
              )}
              {!isSearching && (
                <IconButton
                  type="submit"
                  className="ap-icon-button"
                  underline={false}
                  aria-label="search"
                  style={{padding: 0}}
                  onClick={() => {
                    if (isSearching === true) {
                      if (search.startsWith('#')) {
                        let newSearch = search.substring(1)
                        setRealSearch(newSearch)
                      } else {
                        setRealSearch(search)
                      }
                    } else {
                      setSearching(true)
                    }
                  }}
                >
                  <SearchIcon />
                </IconButton>
              )}
            </div>
          </div>
          <WalkingPanda
            label="Loading..."
            hidden={!groupIds.isLoading}
            style={{
              paddingTop: 120,
              zIndex: 1299,
              left: 8,
              top: 8,
              right: 8,
              bottom: 8,
            }}
          />
          {!groupIds.isLoading && !stillLoading && (
            <div>
              <Tabs
                defaultActiveKey={!_.isEmpty(filteredGroupIds.approval) ? 'pending' : 'upcoming'}
                activeKey={tabActive}
                onSelect={e => areaTabSelect(e)}
                id="uncontrolled-tab-example"
                variant="pills"
                className={`ap-reservation-bookings__tab ${
                  _.isEmpty(filteredGroupIds.approval)
                    ? 'ap-reservation-bookings__width-33'
                    : 'ap-reservation-bookings__width-25'
                }`}
              >
                {!_.isEmpty(filteredGroupIds.approval) && (
                  <Tab eventKey="pending" title="Pending">
                    {tabActive === 'pending' && (
                      <DateArea
                        group_ids={filteredGroupIds.approval}
                        setItemData={setItemData}
                        apiStatus="pending"
                        itemUpdated={itemUpdated}
                        setItemUpdated={setItemUpdated}
                        tabActive={tabActive}
                        search={realSearch.trim()}
                      />
                    )}
                  </Tab>
                )}
                <Tab eventKey="upcoming" title="Upcoming">
                  {tabActive === 'upcoming' && (
                    <DateArea
                      group_ids={filteredGroupIds.configuration}
                      setItemData={setItemData}
                      apiStatus="upcoming"
                      itemUpdated={itemUpdated}
                      setItemUpdated={setItemUpdated}
                      tabActive={tabActive}
                      search={realSearch.trim()}
                    />
                  )}
                </Tab>
                <Tab eventKey="ongoing" title="Ongoing">
                  {tabActive === 'ongoing' && (
                    <DateArea
                      group_ids={filteredGroupIds.configuration}
                      setItemData={setItemData}
                      apiStatus="ongoing"
                      itemUpdated={itemUpdated}
                      setItemUpdated={setItemUpdated}
                      tabActive={tabActive}
                      search={realSearch.trim()}
                    />
                  )}
                </Tab>
                <Tab eventKey="previous" title="Previous">
                  {tabActive === 'previous' && (
                    <DateArea
                      group_ids={filteredGroupIds.configuration}
                      setItemData={setItemData}
                      apiStatus="previous"
                      itemUpdated={itemUpdated}
                      setItemUpdated={setItemUpdated}
                      tabActive={tabActive}
                      search={realSearch.trim()}
                    />
                  )}
                </Tab>
              </Tabs>
            </div>
          )}
        </Grid>

        <Grid item xs={6}>
          <InfoArea
            itemSelected={itemSelected}
            status={status}
            state={state}
            tabActive={tabActive}
            approvalManagerGroups={filteredGroupIds.approval}
            setItemSelected={setItemSelected}
            setItemUpdated={setItemUpdated}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default ReservationBookings
